import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=04b92c45&scoped=true"
import script from "./EmptyList.vue?vue&type=script&lang=ts"
export * from "./EmptyList.vue?vue&type=script&lang=ts"
import style0 from "./EmptyList.vue?vue&type=style&index=0&id=04b92c45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b92c45",
  null
  
)

export default component.exports